import { Text, View } from "react-native";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { useTranslation } from "react-i18next";
import { Ionicons } from "@expo/vector-icons";
import { observer, Observer } from "mobx-react";

const ClientNameLogo = observer(({ client, isForChat }) => {
  const size = isForChat ? 32 : 36;

  const hasInitials =
    client.nameForCoach !== "" || client.surnameForCoach !== "";

  const initialName = client.nameForCoach
    ? client.nameForCoach.charAt(0).toUpperCase()
    : "";
  const initialSurname = client.surnameForCoach
    ? client.surnameForCoach.charAt(0).toUpperCase()
    : "";

  return (
    <View
      style={{
        justifyContent: "center",
        alignItems: "center",
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: Colors.blackColor,
        marginRight: 8,
      }}
    >
      {hasInitials ? (
        <View style={{ flexDirection: "row" }}>
          <Text
            style={{
              fontSize: 13,
              fontWeight: "600",
              color: Colors.whiteColor,
            }}
          >
            {initialName}
          </Text>
          {client.surnameForCoach !== "" && (
            <Text
              style={{
                fontSize: 13,
                fontWeight: "bold",
                color: Colors.whiteColor,
              }}
            >
              {initialSurname}
            </Text>
          )}
        </View>
      ) : (
        <Ionicons name="person" size={20} color={Colors.whiteBlack} />
      )}
    </View>
  );
});

export default ClientNameLogo;
